import { MergeFormConfig, FieldConfig } from "@/types/merge";
import { MergeUtils } from "@/utils/mergeUtils";

export interface CandidateForMerge {
	id: string;
	name: string;
	email: string;
	phone: string;
	function: string;
	skills: string[];
	match_score: number;
	manager: string;
	status: string;
	ai_analysis: any;
	ai_synthesis: string;
	embedding: any;
	linkedin: string;
	linkedin_json: any;
	location: string;
	created_at: string;
	updated_at: string;
	organization_uuid: string;
	default_resume: string;
}

export const candidateMergeConfig: MergeFormConfig<CandidateForMerge> = {
	entityName: "candidates",
	excludeFields: ["id", "embedding", "embedding_specific", "organization_uuid"],
	fields: [
		{
			name: "name",
			type: "text",
			label: "Name",
			mergeBehavior: "manual",
			required: true,
			description: "Candidate's full name"
		},
		{
			name: "email",
			type: "email",
			label: "Email",
			mergeBehavior: "longest",
			required: true,
			description: "Primary email address"
		},
		{
			name: "phone",
			type: "phone",
			label: "Phone",
			mergeBehavior: "longest",
			description: "Primary phone number"
		},
		{
			name: "function",
			type: "text",
			label: "Job Function",
			mergeBehavior: "manual",
			aiMergeEnabled: true,
			description: "Current job title or function"
		},
		{
			name: "skills",
			type: "array",
			label: "Skills",
			mergeBehavior: "combine",
			description: "List of candidate skills"
		},
		{
			name: "status",
			type: "select",
			label: "Status",
			mergeBehavior: "latest",
			possibleValues: ["looking", "open", "unavailable", "hired"],
			description: "Current candidate status"
		},
        {
			name: "ai_synthesis",
			type: "text",
			label: "Synthesis",
			mergeBehavior: "ai",
			aiMergeEnabled: true,
			description: "AI-generated summary of candidate profile"
		},
        {
			name: "ai_analysis",
			type: "presence",
			label: "AI Analysis",
			mergeBehavior: "combine",
			description: "Choose which AI analysis to keep (complex data structure)"
		},
		
		{
			name: "linkedin",
			type: "url",
			label: "LinkedIn URL",
			mergeBehavior: "longest",
			description: "LinkedIn profile URL"
		},		
        
        {
			name: "linkedin_json",
			type: "presence",
			label: "LinkedIn Data",
			mergeBehavior: "combine",
			description: "Choose which LinkedIn data structure to keep"
		},
		{
			name: "location",
			type: "text",
			label: "Location",
			mergeBehavior: "manual",
			description: "Geographic location"
		},
		{
			name: "default_resume",
			type: "text",
			label: "Default Resume",
			mergeBehavior: "latest",
			description: "Default resume document"
		}
	]
};
